import { useLocation } from 'react-router-dom';
import { getLangFromPathname, withLangPrefix } from '../i18n/pathUtils';

/**
 * Returns `lp(path)` — a helper that keeps in-site navigation within the active
 * language. All languages are URL-prefixed: `/en/...`, `/zh/...`, `/tr/...`.
 *
 *   const lp = useLangLink();
 *   <Link to={lp('/banking-license')} />
 */
export default function useLangLink() {
    const { pathname } = useLocation();
    const lang = getLangFromPathname(pathname);
    return (p) => withLangPrefix(lang, p);
}
